import React from 'react'
import { toast } from 'react-toastify'

const UploadValidator = (file, type) => {
    if (type === 'image' || type === 'IMAGE' || type === 'Image') {
        if (file?.type === 'image/jpeg' || file?.type === 'image/png') {
            if (file?.size < 5242880) {
                return true;
            } else {
                toast.error('File size limit exceeded, please check the size of file uploaded', { position: 'top-center' });
                return false;
            }
        } else {
            toast.error("Wrong file format uploaded, only JPEG and PNG formats are supported", { position: 'top-center' });
            return false;
        }
    } else if (type === 'video' || type === 'VIDEO' || type === 'Video') {
        if (file?.type === 'video/mp4' || file?.type === 'video/3gpp') {
            if (file?.size < 16777216) {
                return true;
            } else {
                toast.error('File size limit exceeded, please check the size of file uploaded', { position: 'top-center' });
                return false;
            }
        } else {
            toast.error("Wrong file format uploaded, only MP4 and 3GP formats are supported", { position: 'top-center' });
            return false;
        }
    } else if (type === 'document' || type === 'DOCUMENT' || type === 'Document') {
        if (
            file?.type === 'text/csv' || file?.type === 'application/msword' || file?.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' || file?.type === 'application/pdf' || file?.type === 'application/vnd.ms-powerpoint' || file?.type === 'application/vnd.openxmlformats-officedocument.presentationml.presentation' || file?.type === 'application/vnd.ms-excel' || file?.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            || file?.type === 'text/plain'
        ) {
            if (file?.size < 104857600) {
                return true;
            } else {
                toast.error('File size limit exceeded, please check the size of file uploaded', { position: 'top-center' });
                return false;
            }
        } else {
            toast.error("Wrong file format uploaded, only CSV, DOC, DOCX, PDF, PPT, PPTX, XLS and XLSX formats are supported", { position: 'top-center' });
            return false;
        }
    }
    else if (type === 'audio' || type === 'AUDIO' || type === 'Audio') {
        if (file?.type === 'audio/wav' || file?.type === 'audio/acc' || file?.type === 'audio/mp4' || file?.type === 'audio/m4a') {
            if (file?.size < 16777216) {
                return true;
            } else {
                toast.error('File size limit exceeded, please check the size of file uploaded', { position: 'top-center' });
                return false;
            }
        } else {
            toast.error("Wrong file format uploaded, only MP4, WAV, ACC and M$A formats are supported", { position: 'top-center' });
            return false;
        }
    }
}

export default UploadValidator